
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, FileEdit, Trash2 } from 'lucide-react';
import { draftEntryPath, useDraftStore } from '@/features/tickets';
import { draftsApi } from '@/shared/api/drafts';
import styles from './MyTicketsPortal.module.css';

function formatWhen(iso: string): string {
  const d = new Date(iso);
  const today = new Date();
  const sameDay = d.toDateString() === today.toDateString();
  return sameDay
    ? d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
}

export const DraftsSection: React.FC = () => {
  const draft = useDraftStore((s) => s.draft);
  const loaded = useDraftStore((s) => s.loaded);
  const fetchDraft = useDraftStore((s) => s.fetchDraft);
  const setDraft = useDraftStore((s) => s.setDraft);

  useEffect(() => {
    if (!loaded) void fetchDraft();
  }, [loaded, fetchDraft]);

  if (!draft) return null;

  const handleDiscard = async () => {
    setDraft(null);
    try {
      await draftsApi.discard();
    } catch {
      void fetchDraft();
    }
  };

  return (
    <section className={styles.drafts} aria-label="Незаконченное обращение" data-tour="drafts">
      <div className={styles.draftsHead}>
        <FileEdit size={14} aria-hidden />
        Незаконченное обращение
      </div>
      <ul className={styles.draftsList}>
        <li>
          <div className={styles.draftRow}>
            <Link className={styles.draftRowBody} to={draftEntryPath(draft)}>
              <span className={styles.draftRowTitle}>{draft.subject || 'Без темы'}</span>
              {draft.description && (
                <span className={styles.draftRowDesc}>{draft.description}</span>
              )}
            </Link>
            <span className={styles.draftRowWhen}>{formatWhen(draft.updatedAt)}</span>
            <Link
              className={styles.draftRowDelete}
              to={draftEntryPath(draft)}
              title="Продолжить заполнение"
            >
              <ChevronRight size={14} aria-hidden />
            </Link>
            <button
              type="button"
              className={styles.draftRowDelete}
              data-danger
              title="Выбросить черновик"
              onClick={() => void handleDiscard()}
            >
              <Trash2 size={14} aria-hidden />
            </button>
          </div>
        </li>
      </ul>
    </section>
  );
};
